import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  boxApply1qmzdb3dh90hg as boxApply,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from './AbstractCollection.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import { KtList3hktaavzmj137 as KtList } from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SubListClass;
function SubList() {
  if (SubListClass === VOID) {
    class $ extends AbstractList() {
      static ti(list, fromIndex, toIndex) {
        var $this = this.ui();
        $this.qi_1 = list;
        $this.ri_1 = fromIndex;
        $this.si_1 = 0;
        Companion_instance.f6($this.ri_1, toIndex, $this.qi_1.q2());
        $this.si_1 = toIndex - $this.ri_1 | 0;
        return $this;
      }
      r2(index) {
        Companion_instance.i7(index, this.si_1);
        return this.qi_1.r2(this.ri_1 + index | 0);
      }
      q2() {
        return this.si_1;
      }
      b3(fromIndex, toIndex) {
        Companion_instance.f6(fromIndex, toIndex, this.si_1);
        return SubList().ti(this.qi_1, this.ri_1 + fromIndex | 0, this.ri_1 + toIndex | 0);
      }
    }
    initMetadataForClass($, 'SubList', VOID, VOID, [RandomAccess()]);
    SubListClass = $;
  }
  return SubListClass;
}
var IteratorImplClass;
function IteratorImpl() {
  if (IteratorImplClass === VOID) {
    class $ {
      constructor($outer, $box) {
        boxApply(this, $box);
        this.wi_1 = $outer;
        this.vi_1 = 0;
      }
      q1() {
        return this.vi_1 < this.wi_1.q2();
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().t6();
        var _unary__edvuaz = this.vi_1;
        this.vi_1 = _unary__edvuaz + 1 | 0;
        return this.wi_1.r2(_unary__edvuaz);
      }
    }
    initMetadataForClass($, 'IteratorImpl');
    IteratorImplClass = $;
  }
  return IteratorImplClass;
}
var ListIteratorImplClass;
function ListIteratorImpl() {
  if (ListIteratorImplClass === VOID) {
    class $ extends IteratorImpl() {
      constructor($outer, index, $box) {
        if ($box === VOID)
          $box = {};
        $box.zi_1 = $outer;
        super($outer, $box);
        Companion_instance.z6(index, this.zi_1.q2());
        this.vi_1 = index;
      }
      a7() {
        return this.vi_1 > 0;
      }
      b7() {
        if (!this.a7())
          throw NoSuchElementException().t6();
        this.vi_1 = this.vi_1 - 1 | 0;
        return this.zi_1.r2(this.vi_1);
      }
    }
    initMetadataForClass($, 'ListIteratorImpl');
    ListIteratorImplClass = $;
  }
  return ListIteratorImplClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.e6_1 = 2147483639;
      }
      i7(index, size) {
        if (index < 0 || index >= size) {
          throw IndexOutOfBoundsException().i3('index: ' + index + ', size: ' + size);
        }
      }
      z6(index, size) {
        if (index < 0 || index > size) {
          throw IndexOutOfBoundsException().i3('index: ' + index + ', size: ' + size);
        }
      }
      f6(fromIndex, toIndex, size) {
        if (fromIndex < 0 || toIndex > size) {
          throw IndexOutOfBoundsException().i3('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size);
        }
        if (fromIndex > toIndex) {
          throw IllegalArgumentException().n2('fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
        }
      }
      xg(startIndex, endIndex, size) {
        if (startIndex < 0 || endIndex > size) {
          throw IndexOutOfBoundsException().i3('startIndex: ' + startIndex + ', endIndex: ' + endIndex + ', size: ' + size);
        }
        if (startIndex > endIndex) {
          throw IllegalArgumentException().n2('startIndex: ' + startIndex + ' > endIndex: ' + endIndex);
        }
      }
      sa(oldCapacity, minCapacity) {
        var newCapacity = oldCapacity + (oldCapacity >> 1) | 0;
        if ((newCapacity - minCapacity | 0) < 0)
          newCapacity = minCapacity;
        if ((newCapacity - 2147483639 | 0) > 0)
          newCapacity = minCapacity > 2147483639 ? 2147483647 : 2147483639;
        return newCapacity;
      }
      l7(c) {
        var hashCode_0 = 1;
        var _iterator__ex2g4s = c.p1();
        while (_iterator__ex2g4s.q1()) {
          var e = _iterator__ex2g4s.r1();
          var tmp = imul(31, hashCode_0);
          var tmp1_elvis_lhs = e == null ? null : hashCode(e);
          hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
        }
        return hashCode_0;
      }
      k7(c, other) {
        if (!(c.q2() === other.q2()))
          return false;
        var otherIterator = other.p1();
        var _iterator__ex2g4s = c.p1();
        while (_iterator__ex2g4s.q1()) {
          var elem = _iterator__ex2g4s.r1();
          var elemOther = otherIterator.r1();
          if (!equals(elem, elemOther)) {
            return false;
          }
        }
        return true;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var AbstractListClass;
function AbstractList() {
  if (AbstractListClass === VOID) {
    class $ extends AbstractCollection() {
      static ui() {
        return this.n6();
      }
      p1() {
        return new (IteratorImpl())(this);
      }
      r4(element) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.indexOfFirst' call
          var index = 0;
          var _iterator__ex2g4s = this.p1();
          while (_iterator__ex2g4s.q1()) {
            var item = _iterator__ex2g4s.r1();
            if (equals(item, element)) {
              tmp$ret$0 = index;
              break $l$block;
            }
            index = index + 1 | 0;
          }
          tmp$ret$0 = -1;
        }
        return tmp$ret$0;
      }
      v2(index) {
        return new (ListIteratorImpl())(this, index);
      }
      b3(fromIndex, toIndex) {
        return SubList().ti(this, fromIndex, toIndex);
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(!(other == null) ? isInterface(other, KtList()) : false))
          return false;
        return Companion_instance.k7(this, other);
      }
      hashCode() {
        return Companion_instance.l7(this);
      }
    }
    initMetadataForClass($, 'AbstractList', VOID, VOID, [KtList()]);
    AbstractListClass = $;
  }
  return AbstractListClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance23tt71mgnug0i,
  AbstractList as AbstractList3ck35puwbp1e9,
};
//endregion

//# sourceMappingURL=AbstractList.mjs.map
